import { useState, useEffect } from 'react';
import { Maximize, Smartphone, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

export const PreviewPanel = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [streamContent, setStreamContent] = useState('');

  // Функция для обновления контента стрима
  const updateStreamContent = (content: string) => {
    setStreamContent(prev => prev + content);
  };

  return (
    <div className="panel flex flex-col flex-1">
      <div className="panel-header">
        <span className="text-sm text-muted-foreground">
          Preview
        </span>
        <div className="flex gap-1">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setIsMobile(!isMobile)}
            className="icon-button"
          >
            <Smartphone className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setIsFullscreen(!isFullscreen)}
            className="icon-button"
          >
            <Maximize className="h-4 w-4" />
          </Button>
          <Button 
            variant="ghost" 
            size="icon" 
            className="icon-button"
            onClick={() => setStreamContent('')}
          >
            <RefreshCw className="h-4 w-4" />
          </Button>
        </div>
      </div>
      <div className={`flex-1 bg-background p-4 overflow-auto ${isMobile ? 'max-w-md mx-auto' : ''}`}>
        <pre className="whitespace-pre-wrap font-mono text-sm">
          {streamContent}
        </pre>
      </div>
    </div>
  );
};